import { render, staticRenderFns } from "./KnowledgeContentFolderMoveView.vue?vue&type=template&id=7de76c4e&"
import script from "./KnowledgeContentFolderMoveView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeContentFolderMoveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports